import React from "react";
import { Loading } from "..";
import { QuestionInterface, AnswerInterface, ArrayHelper, PendingCommand } from "../../helpers";
import { AnswerHelper } from "../../helpers/AnswerHelper";
import { Answers } from "./Answers"
import { useLocation } from 'react-router-dom';

interface Props {
  subscriptionData?: any,
  questions?: QuestionInterface[],
  answers?: AnswerInterface[],
  messageId?: number,
  playlistId?: number,
  overlayId?: number,
  sendCommand?: (cmd: PendingCommand) => void
}

export const RootAnswers: React.FC<Props> = props => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null);
  const [answers, setAnswers] = React.useState<AnswerInterface[]>(null);
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);


  const loadQuestions = () => {
    if (props.questions) setQuestions(AnswerHelper.buildQuestionTree(props.questions, 0));
  }

  const loadAnswers = () => {
    if (props.answers && props.questions) {
      const result = props.answers;
      props.questions.forEach(q => {
        const existing = ArrayHelper.getOne(result, "questionId", q.id);
        if (!existing) {
          const subVal = (props.subscriptionData) ? props.subscriptionData[q.keyName] : ""
          result.push({ questionId: q.id, messageId: props.messageId, playlistId: props.playlistId, overlayId: props.overlayId, id: 0, value: subVal?.toString() || q.placeholder })
        }
      })
      setAnswers(result);

      setTimeout(populateFromQS, 100);
      
    }
    
  }

  const populateFromQS = () => {
    props.questions?.forEach(q => {
      const param = searchParams.get(q.keyName);
      if (param) handleValueUpdate(q.id, param);
    });
  }


  const handleValueUpdate = (questionId: number, newValue: string) => {
    const result = [...answers];
    const item = ArrayHelper.getOne(result, "questionId", questionId);
    item.value = newValue;
    setAnswers(result);
    props.sendCommand({ action: "updatePreview", parameter: { questions, answers } });;
  }

  React.useEffect(loadQuestions, [props.questions]); // eslint-disable-line
  React.useEffect(loadAnswers, [props.questions, props.answers, props.subscriptionData]); // eslint-disable-line


  const getContent = () => {
    if (!questions) return <Loading />
    else return <Answers subscriptionData={props.subscriptionData} questions={questions} answers={answers} updateValue={handleValueUpdate} sendCommand={props.sendCommand} />
  }

  return (
    <>
      {getContent()}
    </>
  );
}